export class TechFaq {
  public id: number;
  public questionKz: string;
  public questionRu: string;
  public questionEn: string;
  public question: string;
  public answerKz: string;
  public answerRu: string;
  public answerEn: string;
  public answer: string;
  public likesCount: number;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/tech-support/tech-faq.ts